/**
 * 契約値超過判定ユーティリティ。
 *
 * MW → kWh/30min 換算:
 *   1MW × 30min = 500kWh  (= mw × 1000 / 2)
 *   design/supply/48data.html line 950: mw * 1000 / 2
 *
 * AC-018: 契約値超過しきい値の単位換算。
 */

/**
 * contractVolumeMw (MW) から 30 分コマ単位の kWh 上限値を算出する。
 * 0 以下の MW は undefined を返す (超過チェック不要)。
 */
export function contractMwToThresholdKwh(
  contractMw: number,
): number | undefined {
  if (contractMw <= 0) return undefined
  // 1MW × 30min = 500kWh  (= mw × 1000 / 2)
  return contractMw * 500
}

/**
 * セル値が契約値超過かどうかを判定する。
 *
 * @param value - セル値 (kWh/30min)
 * @param contractMwStr - 契約量 (MW)。undefined の場合は超過なし
 */
export function isOverContractThreshold(
  value: number | null | undefined,
  contractMwStr: string | undefined,
): boolean {
  if (value === null || value === undefined) return false
  if (contractMwStr === undefined) return false
  const contractMw = Number(contractMwStr)
  const threshold = contractMwToThresholdKwh(contractMw)
  if (threshold === undefined) return false
  return value > threshold
}
